
import { Vue, Options } from "vue-class-component";
import {
  INTERNET_ERROR,
  INTERNAL_SERVER_ERROR,
} from "@/app/infrastructures/misc/Utils";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import {
  ListTicketPusatResolusiRequest,
  CheckTicketPusatResolusiRequest,
  TicketCounterPusatResolusiRequest,
} from "@/data/payload/api/PusatResolusiV2ApiRequest";
import { ListTicketPusatResolusi } from "@/domain/entities/PusatResolusiV2";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import CustomDropdown from "@/app/ui/components/custom-dropdown/index.vue";
import Checkbox from "primevue/checkbox";
import { OptionsClass } from "@/domain/entities/MainApp";
import { PaginationV2 } from "@/domain/entities/Pagination";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { mappingListPriority } from "../utils/status-mapping";

const filter = {
  needToBeSolved: false,
  newMessage: false,
  mention: false,
  category: [] as string[],
  status: [] as string[],
  prioritas: [] as string[],
  sort: "asc",
  countNeedToBeSolved: 0,
  countNewMessage: 0,
  countMention: 0,
  search: "",
};

interface FilterItem {
  label: string;
  type: string;
  flag: keyof typeof filter;
  countKey: keyof typeof filter;
  disable: boolean;
  showButton: boolean;
}

@Options({
  components: {
    Skeleton,
    CustomDropdown,
    Checkbox,
  },
})
export default class PusatResolusiV2TabTicket extends Vue {
  INTERNAL_SERVER_ERROR = INTERNAL_SERVER_ERROR;
  INTERNET_ERROR = INTERNET_ERROR;
  errorState = "";
  tabActive = "";
  tabLoading = false;
  loading = false;
  openFilterSort = false;
  tabs = [
    {
      name: "ticket_escalate",
      title: "Tiket eskalasi",
      isNotif: false,
      id: "tab_list_table_tiket_eskalasi",
      idNotif: "new_escalate_ticket",
    },
    {
      name: "my_ticket",
      title: "Tiket saya",
      isNotif: false,
      id: "tab_list_table_tiket_saya",
      idNotif: "new_notification_and_mention_ticket_saya",
    },
    {
      name: "ticket_followed",
      title: "Tiket diikuti",
      isNotif: false,
      id: "tab_list_table_tiket_diikuti",
      idNotif: "new_notification_and_mention_followed_ticket",
    },
  ];
  filter = {
    category: [],
    status: [],
    prioritas: [],
    sort: "asc",
    countNeedToBeSolved: 0,
    countNewMessage: 0,
    countMention: 0,
    needToBeSolved: true,
    newMessage: false,
    mention: false,
    search: "",
  };
  tempFilterTicket = {
    ticketEscalate: {
      needToBeSolved: true,
      newMessage: false,
      mention: false,
      category: [],
      status: [],
      prioritas: [],
      sort: "asc",
      search: "",
    },
    myTicket: {
      needToBeSolved: false,
      newMessage: false,
      mention: false,
      category: [],
      status: [],
      prioritas: [],
      sort: "asc",
      search: "",
    },
    ticketFollowed: {
      needToBeSolved: false,
      newMessage: false,
      mention: false,
      category: [],
      status: [],
      prioritas: [],
      sort: "asc",
      search: "",
    },
  };

  onSearch(value: string) {
    this.dataListTicket.pagination.page = 1;
    this.filter.search = value;
    this.tempFilterTicketSearch();
    this.getListTicket();
  }

  clearSearch() {
    this.filter.search = "";
    this.tempFilterTicketSearch();
    this.getListTicket();
  }

  created() {
    const tab = this.$route.name?.toString() ?? "";
    this.changeTabs(tab);
  }

  mounted() {
    this.getTicketCounter("ticket_escalate");
    this.getTicketCounter("my_ticket");
    this.getTicketCounter("ticket_followed");
    this.getListCategory();
    this.getListTicket();
  }

  get disableFilterButton() {
    return !this.filter.category.length && !this.filter.status.length && !this.filter.prioritas.length;
  }

  get filterButtons(): FilterItem[] {
    return [
      {
        label: "Perlu diselesaikan",
        type: "need_to_be_solved",
        flag: "needToBeSolved",
        countKey: "countNeedToBeSolved",
        disable: this.tabActive === "ticket_escalate",
        showButton: this.tabActive === "ticket_escalate"
      },
      {
        label: "Pesan baru",
        type: "new_message",
        flag: "newMessage",
        countKey: "countNewMessage",
        disable: false,
        showButton: true
      },
      {
        label: "Mention",
        type: "mention",
        flag: "mention",
        countKey: "countMention",
        disable: false,
        showButton: true
      },
    ];
  }

  get emptyHeaderMessage() {
    return this.errorState === INTERNET_ERROR
      ? "Jaringan internet terputus"
      : this.errorState === INTERNAL_SERVER_ERROR
      ? "Terjadi gangguan sistem"
      : this.errorState === "no_data"
      ? "Belum ada kendala"
      : "Kendala tidak ditemukan";
  }

  get emptyMessage() {
    return this.errorState === INTERNET_ERROR
      ? "Periksa jaringan internal Anda."
      : this.errorState === INTERNAL_SERVER_ERROR
      ? 'Klik "Muat ulang" atau coba beberapa saat lagi.'
      : this.errorState === "no_data"
      ? "Yuk! Mulai laporkan kendala Anda."
      : "Cek kembali atau cari nomor kendala/STT/shipment id lain.";
  }

  get iconEmpty() {
    return this.errorState === INTERNET_ERROR
      ? "error-internet"
      : this.errorState === INTERNAL_SERVER_ERROR
      ? "error-token-ngen"
      : this.errorState === "no_data"
      ? "box_no_data"
      : "ill_spot_search";
  }

  get statusOptions() {
    return [
      { name: "Baru", value: "NEW" },
      { name: "Dalam proses", value: "WORKING" },
      { name: "Dalam eskalasi", value: "ESCALATED" },
      { name: "Ditunda sementara", value: "ON HOLD" },
      { name: "Selesai", value: "SOLVED" },
      { name: "Ditutup", value: "CLOSED" },
    ];
  }

  get priorityOptions() {
    return [
      { name: "Hard complaint", value: "HARD COMPLAINT" },
      { name: "Agregator", value: "AGREGATOR" },
      { name: "Diamond", value: "DIAMOND" },
      { name: "Marketplace", value: "MARKETPLACE" },
      { name: "Corporate", value: "CORPORATE" },
      { name: "CUST Platinum", value: "CUST PLATINUM" },
      { name: "CUST Gold", value: "CUST GOLD" },
      { name: "CUST Silver", value: "CUST SILVER" },
      { name: "CUST Bronze", value: "CUST BRONZE" },
      { name: "POS Diamond", value: "POS DIAMOND" },
      { name: "POS Platinum", value: "POS PLATINUM" },
      { name: "POS Gold", value: "POS GOLD" },
      { name: "POS Silver", value: "POS SILVER" },
      { name: "POS Bronze", value: "POS BRONZE" },
    ];
  }

  get filterLength() {
    return (
      this.filter.category?.length +
      this.filter.status?.length +
      this.filter.prioritas?.length
    );
  }

  get filterSortSelected() {
    return this.filter.sort === "asc" ? "Terlama" : "Terbaru";
  }

  currentPriority(priority: string) {
    return mappingListPriority(priority.toUpperCase());
  }

  get columns() {
    return [...this.columnFirst, ...this.columnSecond];
  }

  handleTiketRead(isRead: boolean) {
    if (!isRead) {
      return "bg-gray-lp-1200"
    }
  }

  get columnFirst() {
    return [
      {
        name: "No. Kendala",
        styleHead: "w-40 text-left whitespace-no-wrap break-all mx-3",
        render: (item: any) => {
          return `
              <div class="text-sm text-gray-lp-300 mx-3 break-all">
                ${
                  item.needToBeSolved
                    ? '<div class="bg-red-lp-100 text-white font-bold px-1 absolute left-0 top-0 flex items-center justify-center" style="font-size: 10px; border-radius: 0 0 10px 0; height: 16px;">Perlu diselesaikan</div>'
                    : ""
                }
                <div class="flex items-center gap-2">
                  <span>
                    ${item?.issueNo || "-"}
                  </span>
                  <div class="flex items-center gap-1">
                    ${
                      item.unreadMessage
                        ? this.handleIconTicket("chat-warning")
                        : ""
                    }
                    ${item.mentioned ? this.handleIconTicket("mention") : ""}
                  </div>
                </div>
              </div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
      {
        name: "No. STT/shipment id",
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="text-sm text-gray-lp-300 break-words">
            ${item?.sttOrShipmentNumber || "-"}
          </div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
      {
        name: "Kategori kendala",
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="text-sm text-gray-lp-300">${item?.categoryIssue ||
            "-"}</div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
      {
        name: "Prioritas",
        styleHead: "w-40 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="text-sm font-medium px-2 py-0.5 rounded-md ${this.currentPriority(
            item.ticketPriority
          ).bgColor} ${this.currentPriority(item.ticketPriority).color}">${this.currentPriority(item.ticketPriority)?.label}</div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
    ];
  }

  get columnSecond() {
    return [
      {
        name: "Status",
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="text-sm font-medium ${item?.statusData.text} ${
            item?.statusData.background
          } rounded-2xl px-2 py-0.5">${item?.statusData.label || "-"}</div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
      {
        name: "Waktu dibuat",
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="text-sm text-gray-lp-300">
                    <span>
                        ${formatDate(item.createdAt)}
                    </span><br/>
                    <span class="text-gray-lp-600">
                        ${item?.createdBy || "-"}
                    </span>
                </div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
      {
        name: "Atur",
        styleHead: "w-16 text-left whitespace-no-wrap",
        key: "button_column",
        styleButton: (item: any) => {
          if (this.tabActive === "ticket_escalate") {
            if (item.eligibleAction === "view") {
              return {
                flat: true,
                compact: true,
                class: "w-full",
                icon: "ics_o_eye_red",
                clickFunction: () => {
                  this.$router.push(`/pusat-resolusi-v2/detail/${item.id}`);
                },
              };
            } else if (item.eligibleAction === "assign_to_me") {
              return {
                flat: true,
                compact: true,
                class: "w-full",
                icon: "ics_o_document_red",
                clickFunction: () => {
                  this.$router.push(`/pusat-resolusi-v2/detail/${item.id}`);
                },
              };
            } else if (
              item.eligibleAction === "ineligible_to_assign" ||
              item.eligibleAction === "assigned"
            ) {
              const messageTooltip = `Sedang dieskalasi oleh ${item.assignToUsername}`;
              return {
                flat: true,
                compact: true,
                class: "w-full",
                icon: "ics_o_document_gray",
                toolTip: messageTooltip,
              };
            }
          } else if (
            this.tabActive === "my_ticket" ||
            this.tabActive === "ticket_followed"
          ) {
            return {
              flat: true,
              compact: true,
              class: "w-full",
              icon: "ics_o_eye_red",
              clickFunction: () => {
                this.$router.push(`/pusat-resolusi-v2/detail/${item.id}`);
              },
            };
          }
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
    ];
  }

  get firstRowHeaderColumns() {
    const temp: Array<any> = [
      {
        name: "No. Kendala",
        styleHead: "w-40 text-left whitespace-no-wrap break-all",
      },
      {
        name: "No. STT/shipment id",
        styleHead: "w-50 text-left whitespace-no-wrap",
      },
      {
        name: "Kategori kendala",
        styleHead: "w-48 text-left whitespace-no-wrap",
      },
      {
        name: "Prioritas",
        styleHead: "w-40 text-left whitespace-no-wrap",
      },
      {
        name: "Status",
        styleHead: "w-48 text-left whitespace-no-wrap",
      },
      {
        name: "Waktu dibuat",
        styleHead: "w-48 text-left whitespace-no-wrap",
      },
      {
        name: "Atur",
        styleHead: "w-16 text-left whitespace-no-wrap",
      },
    ];
    return temp;
  }

  handleIconTicket(iconType: string) {
    if (iconType === "mention") {
      return '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.16699 7.00008C1.16699 10.2142 3.78616 12.8334 7.00033 12.8334C8.27199 12.8334 9.48533 12.4309 10.5003 11.6667C10.757 11.4742 10.8095 11.1067 10.617 10.8501C10.4245 10.5934 10.057 10.5409 9.80033 10.7334C8.98949 11.3459 8.02116 11.6667 7.00033 11.6667C4.42783 11.6667 2.33366 9.57258 2.33366 7.00008C2.33366 4.42758 4.42783 2.33341 7.00033 2.33341C9.57283 2.33341 11.667 4.42758 11.667 7.00008C11.667 7.48425 11.2762 7.87508 10.792 7.87508C10.3078 7.87508 9.91699 7.48425 9.91699 7.00008C9.91699 5.39008 8.61033 4.08342 7.00033 4.08342C5.39033 4.08342 4.08366 5.39008 4.08366 7.00008C4.08366 8.61008 5.39033 9.91675 7.00033 9.91675C8.03937 9.91675 8.95208 9.37252 9.46875 8.55375C9.82537 8.85793 10.2876 9.04175 10.792 9.04175C11.9178 9.04175 12.8337 8.12592 12.8337 7.00008C12.8337 3.78591 10.2145 1.16675 7.00033 1.16675C3.78616 1.16675 1.16699 3.78591 1.16699 7.00008ZM8.75033 7.00008C8.75033 6.03758 7.96283 5.25008 7.00033 5.25008C6.03783 5.25008 5.25033 6.03758 5.25033 7.00008C5.25033 7.96258 6.03783 8.75008 7.00033 8.75008C7.96283 8.75008 8.75033 7.96258 8.75033 7.00008Z" fill="#B82025"/></svg>';
    } else if (iconType === "chat-warning") {
      return '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.91699 1.16675C1.95049 1.16675 1.16699 1.95025 1.16699 2.91675V8.76953C1.16699 9.73602 1.95049 10.5195 2.91699 10.5195H3.79199V12.2501C3.79199 12.4691 3.91464 12.6696 4.10959 12.7694C4.30454 12.8691 4.53893 12.8513 4.71655 12.7232L7.77207 10.5195H11.0837C12.0502 10.5195 12.8337 9.73602 12.8337 8.76953V2.91675C12.8337 1.95025 12.0502 1.16675 11.0837 1.16675H2.91699ZM7.57785 4.08342C7.57785 3.76125 7.31799 3.50008 6.99742 3.50008C6.67686 3.50008 6.41699 3.76125 6.41699 4.08342V5.83342C6.41699 6.15558 6.67686 6.41675 6.99742 6.41675C7.31799 6.41675 7.57785 6.15558 7.57785 5.83342V4.08342ZM6.99742 7.00008C6.67686 7.00008 6.41699 7.26125 6.41699 7.58342C6.41699 7.90558 6.67686 8.16675 6.99742 8.16675H7.00323C7.32379 8.16675 7.58366 7.90558 7.58366 7.58342C7.58366 7.26125 7.32379 7.00008 7.00323 7.00008H6.99742Z" fill="#B82025"/></svg>';
    }
  }

  // category
  listCategory: OptionsClass[] = [];
  async getListCategory() {
    try {
      this.listCategory = [];
      const res = await PusatResolusiV2Controller.getListCategory(
        new CheckTicketPusatResolusiRequest()
      );

      // sort by disabled
      const data = res.map(
        (item) =>
          new OptionsClass({
            name: item.label,
            value: item.code,
            label: item.template, // label as template data
            disabled: !item.isEligible,
          })
      );
      this.listCategory = data.sort((a, b) => {
        if (!!a.disabled === !!b.disabled) return 0;
        if (a.disabled && !b.disabled) return 1;
        return -1;
      });
    } catch (error) {
      return error;
    }
  }

  hubIdValue(tab: string) {
    return tab === "ticket_escalate" ? getHubData()?.hubId || "0" : "0";
  }

  async getTicketCounter(tab: string) {
    try {
      const notificationTicket = await PusatResolusiV2Controller.getTicketCounter(
        new TicketCounterPusatResolusiRequest({
          ticketType: tab,
          hubId: this.hubIdValue(tab)
        })
      );

      if (this.tabActive === tab)  {
        this.filter.countNeedToBeSolved =
          notificationTicket?.countTicketNeedToBeSolved;
        this.filter.countNewMessage = notificationTicket?.countNewMessage;
        this.filter.countMention = notificationTicket?.countMention;
      }

      // notif ticket tabs
      this.mapTicketNotif(notificationTicket, tab);
    } catch (error) {
      return error;
    }
  }

  mapTicketNotif(notificationTicket: any, tab: string) {
    this.tabs.map((item) => {
        item.name === tab
          ? (item.isNotif =
              notificationTicket.countNewMessage + notificationTicket.countMention > 0
                ? true
                : false)
          : item;
      });
  }

  dataListTicket: ListTicketPusatResolusi = new ListTicketPusatResolusi();
  async getListTicket() {
    this.errorState = "";
    try {
      this.tabLoading = true;
      this.loading = true;
      const response = await PusatResolusiV2Controller.getListTicket(
        new ListTicketPusatResolusiRequest({
          page: this.dataListTicket.pagination.page
            ? this.dataListTicket.pagination.page
            : 1,
          limit: this.dataListTicket.pagination.limit
            ? this.dataListTicket.pagination.limit
            : 20,
          ticketType: this.tabActive,
          needToBeSolved: this.filter.needToBeSolved,
          newMessage: this.filter.newMessage,
          mentioned: this.filter.mention,
          sortByDate: this.filter.sort,
          search: this.filter.search,
          categoryIssueCode: this.filter.category.join(","),
          statusTicket: this.filter.status.join(","),
          ticketPriority: this.filter.prioritas.join(","),
          hubId: this.hubIdValue(this.tabActive)
        })
      );

      this.dataListTicket = new ListTicketPusatResolusi({
        pagination: new PaginationV2({
          page: response.pagination.page,
          limit: response.pagination.limit,
          totalData: response.pagination.totalData,
        }),
        data: response.data,
      });

      this.errorState = this.isNoDataKendala();
    } catch (error) {
      this.handleError(error);
    } finally {
      this.tabLoading = false;
      this.loading = false;
    }
  }

  isNoDataKendala() {
    const {
      category,
      status,
      prioritas,
      search,
      newMessage,
      needToBeSolved,
      mention,
    } = this.filter;

    const isCommonEmpty =
      !category.length &&
      !status.length &&
      !prioritas.length &&
      !search &&
      !this.dataListTicket.data.length;

    if (this.tabActive === "ticket_escalate") {
      return this.validateNoKendala(
        isCommonEmpty,
        newMessage,
        needToBeSolved,
        mention
      );
    } else {
      return this.validateNoKendala(
        isCommonEmpty,
        newMessage,
        needToBeSolved,
        mention
      );
    }
  }

  validateNoKendala(
    isCommonEmpty: boolean,
    newMessage: boolean,
    needToBeSolved: boolean,
    mention: boolean
  ) {
    if (this.tabActive === "ticket_escalate") {
      return isCommonEmpty && !newMessage ? "no_data" : "";
    } else {
      return isCommonEmpty && !newMessage && !needToBeSolved && !mention
        ? "no_data"
        : "";
    }
  }

  handleError(error: any) {
    if (!error?.response) {
      this.errorState = INTERNET_ERROR;
    } else {
      this.errorState = INTERNAL_SERVER_ERROR;
    }
  }

  changeTabs(value: string) {
    this.$router.push({
      name: value
    })
    this.dataListTicket = new ListTicketPusatResolusi();
    this.tabActive = value;
    this.tempFilterTicketFunc(value);
    this.tempFilterTicketSelect();
    this.tempFilterTicketSort();
    this.getTicketCounter(value);
    this.getListTicket();
  }

  tempFilterTicketFunc(tab: string) {
    if (tab === "ticket_escalate") {
      this.filter.needToBeSolved = this.tempFilterTicket.ticketEscalate.needToBeSolved;
      this.filter.newMessage = this.tempFilterTicket.ticketEscalate.newMessage;
      this.filter.mention = this.tempFilterTicket.ticketEscalate.mention;
      this.filter.category = this.tempFilterTicket.ticketEscalate.category;
      this.filter.status = this.tempFilterTicket.ticketEscalate.status;
      this.filter.prioritas = this.tempFilterTicket.ticketEscalate.prioritas;
      this.filter.sort = this.tempFilterTicket.ticketEscalate.sort;
      this.filter.search = this.tempFilterTicket.ticketEscalate.search;
    } else if (tab === "my_ticket") {
      this.filter.needToBeSolved = this.tempFilterTicket.myTicket.needToBeSolved;
      this.filter.newMessage = this.tempFilterTicket.myTicket.newMessage;
      this.filter.mention = this.tempFilterTicket.myTicket.mention;
      this.filter.category = this.tempFilterTicket.myTicket.category;
      this.filter.status = this.tempFilterTicket.myTicket.status;
      this.filter.prioritas = this.tempFilterTicket.myTicket.prioritas;
      this.filter.sort = this.tempFilterTicket.myTicket.sort;
      this.filter.search = this.tempFilterTicket.myTicket.search;
    } else if (tab === "ticket_followed") {
      this.filter.needToBeSolved = this.tempFilterTicket.ticketFollowed.needToBeSolved;
      this.filter.newMessage = this.tempFilterTicket.ticketFollowed.newMessage;
      this.filter.mention = this.tempFilterTicket.ticketFollowed.mention;
      this.filter.category = this.tempFilterTicket.ticketFollowed.category;
      this.filter.status = this.tempFilterTicket.ticketFollowed.status;
      this.filter.prioritas = this.tempFilterTicket.ticketFollowed.prioritas;
      this.filter.sort = this.tempFilterTicket.ticketFollowed.sort;
      this.filter.search = this.tempFilterTicket.ticketFollowed.search;
    }
  }

  isTabActive(name: string) {
    return name === this.tabActive;
  }

  resetFilter() {
    this.filter.category = [];
    this.filter.status = [];
    this.filter.prioritas = [];
    this.dataListTicket.pagination.page = 1;
    this.tempFilterTicketSelect();
    this.getListTicket();
    const filterRef: any = this.$refs.advancedFilter;
    filterRef.closeFilter();
  }

  filterTicket(value: string) {
    if (value === "need_to_be_solved") {
      this.filter.needToBeSolved = !this.filter.needToBeSolved;
    } else if (value === "new_message") {
      this.filter.newMessage = !this.filter.newMessage;
    } else if (value === "mention") {
      this.filter.mention = !this.filter.mention;
    }

    this.dataListTicket.pagination.page = 1;
    this.filterTicketTemp();
    this.getListTicket();
  }

  filterTicketTemp() {
    if (this.tabActive === "ticket_escalate") {
      this.tempFilterTicket.ticketEscalate.needToBeSolved = this.filter.needToBeSolved;
      this.tempFilterTicket.ticketEscalate.newMessage = this.filter.newMessage;
      this.tempFilterTicket.ticketEscalate.mention = this.filter.mention;
    } else if (this.tabActive === "my_ticket") {
      this.tempFilterTicket.myTicket.needToBeSolved = this.filter.needToBeSolved;
      this.tempFilterTicket.myTicket.newMessage = this.filter.newMessage;
      this.tempFilterTicket.myTicket.mention = this.filter.mention;
    } else if (this.tabActive === "ticket_followed") {
      this.tempFilterTicket.ticketFollowed.needToBeSolved = this.filter.needToBeSolved;
      this.tempFilterTicket.ticketFollowed.newMessage = this.filter.newMessage;
      this.tempFilterTicket.ticketFollowed.mention = this.filter.mention;
    }
  }

  tempFilterTicketSelect() {
    if (this.tabActive === "ticket_escalate") {
      this.tempFilterTicket.ticketEscalate.category = this.filter.category;
      this.tempFilterTicket.ticketEscalate.status = this.filter.status;
      this.tempFilterTicket.ticketEscalate.prioritas = this.filter.prioritas;
    } else if (this.tabActive === "my_ticket") {
      this.tempFilterTicket.myTicket.category = this.filter.category;
      this.tempFilterTicket.myTicket.status = this.filter.status;
      this.tempFilterTicket.myTicket.prioritas = this.filter.prioritas;
    } else if (this.tabActive === "ticket_followed") {
      this.tempFilterTicket.ticketFollowed.category = this.filter.category;
      this.tempFilterTicket.ticketFollowed.status = this.filter.status;
      this.tempFilterTicket.ticketFollowed.prioritas = this.filter.prioritas;
    }
  }

  tempFilterTicketSort() {
    if (this.tabActive === "ticket_escalate") {
      this.tempFilterTicket.ticketEscalate.sort = this.filter.sort;
    } else if (this.tabActive === "my_ticket") {
      this.tempFilterTicket.myTicket.sort = this.filter.sort;
    } else if (this.tabActive === "ticket_followed") {
      this.tempFilterTicket.ticketFollowed.sort = this.filter.sort;
    }
  }

  tempFilterTicketSearch() {
    if (this.tabActive === "ticket_escalate") {
      this.tempFilterTicket.ticketEscalate.search = this.filter.search;
    } else if (this.tabActive === "my_ticket") {
      this.tempFilterTicket.myTicket.search = this.filter.search;
    } else if (this.tabActive === "ticket_followed") {
      this.tempFilterTicket.ticketFollowed.search = this.filter.search;
    }
  }

  filterSort(sort: string) {
    this.filter.sort = sort;
    this.dataListTicket.pagination.page = 1;
    this.tempFilterTicketSort();
    this.getListTicket();
    this.openFilterSort = false;
  }

  filterSelect() {
    this.dataListTicket.pagination.page = 1;
    this.tempFilterTicketSelect();
    this.getListTicket();
    const filterRef: any = this.$refs.advancedFilter;
    filterRef.closeFilter()
  }
}
